import { SVGProps, Ref, forwardRef, useId } from 'react';

export const MaxBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <mask
                    id={`${_uniqueId}mask0_17073_739`}
                    style={{
                        maskType: 'alpha',
                    }}
                    maskUnits="userSpaceOnUse"
                    x={1}
                    y={1}
                    width={22}
                    height={22}
                    suppressHydrationWarning
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.236 22.88c-2.159 0-3.162-.315-4.906-1.575-1.103 1.418-4.596 2.525-4.749.63 0-1.422-.315-2.624-.672-3.936C1.483 16.383 1 14.583 1 11.975 1 5.745 6.117 1.059 12.179 1.059c6.067 0 10.82 4.917 10.82 10.973a10.8 10.8 0 0 1-3.135 7.648 10.83 10.83 0 0 1-7.628 3.2m.09-16.437c-2.953-.152-5.253 1.89-5.763 5.09-.42 2.65.326 5.879.961 6.046.305.074 1.072-.545 1.55-1.023.79.546 1.71.873 2.669.95 1.47.07 2.91-.438 4.009-1.416a5.61 5.61 0 0 0 1.869-3.816 5.6 5.6 0 0 0-1.456-3.995 5.62 5.62 0 0 0-3.84-1.83z"
                        fill="#4FBCFC"
                    />
                </mask>
                <g mask={`url(#${_uniqueId}mask0_17073_739)`} suppressHydrationWarning>
                    <g filter={`url(#${_uniqueId}filter0_f_17073_739)`} suppressHydrationWarning>
                        <path
                            d="M24.167 10.167c0 8.1-6.567 14.666-14.667 14.666S-5.167 18.267-5.167 10.167 1.4-4.5 9.5-4.5s14.667 6.567 14.667 14.667"
                            fill="#2A40F1"
                        />
                        <path
                            d="M40.667-1.75c0 8.1-6.567 14.667-14.667 14.667S11.333 6.35 11.333-1.75 17.9-16.417 26-16.417 40.667-9.85 40.667-1.75"
                            fill="#8950E1"
                        />
                        <path
                            d="M15 26.667c0 8.1-6.566 14.666-14.667 14.666s-14.666-6.566-14.666-14.666S-7.767 12 .333 12 15 18.567 15 26.667"
                            fill="#4AC1FC"
                        />
                        <path
                            d="M41.583 23c0 8.1-6.566 14.667-14.666 14.667S12.25 31.1 12.25 23 18.817 8.333 26.917 8.333 41.583 14.9 41.583 23"
                            fill="#A261DF"
                        />
                    </g>
                </g>
            </g>
            <defs>
                <filter
                    id={`${_uniqueId}filter0_f_17073_739`}
                    x={-25.608}
                    y={-27.692}
                    width={78.467}
                    height={80.3}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={5.638} result="effect1_foregroundBlur_17073_739" />
                </filter>
            </defs>
        </svg>
    );
});
MaxBrandSize24Glyph.displayName = 'MaxBrandSize24Glyph';
